import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { BankTransaction } from '../models/bank-transaction/bank-transaction';
import { PagedResult } from './bank-account.proxy.service';

export interface BankTransactionSearchCommand {
  number?: string | null;
  bankAccountCode?: string | null;
  bankingReference?: string | null;
  concept?: string | null;
  financialCompanyIds?: string[] | null;
  statuses?: number[] | null;
  movementTypes?: number[] | null;
  from?: string | null;
  to?: string | null;
}

@Injectable({ providedIn: 'root' })
export class BankTransactionProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/bank-transactions';

  public getAll(): Observable<ApiResponse<BankTransaction[]>> {
    return this.httpClient.get<ApiResponse<BankTransaction[]>>(`${this.baseUrl}/all`);
  }

  public getById(id: string): Observable<ApiResponse<BankTransaction>> {
    return this.httpClient.get<ApiResponse<BankTransaction>>(`${this.baseUrl}/${id}`);
  }

  public createDraft(data: BankTransaction): Observable<ApiResponse<BankTransaction>> {
    return this.httpClient.post<ApiResponse<BankTransaction>>(this.baseUrl, data);
  }

  public updateDraft(id: string, data: BankTransaction): Observable<ApiResponse<BankTransaction>> {
    return this.httpClient.put<ApiResponse<BankTransaction>>(`${this.baseUrl}/${id}`, data);
  }

  public post(id: string): Observable<ApiResponse<BankTransaction>> {
    return this.httpClient.post<ApiResponse<BankTransaction>>(`${this.baseUrl}/${id}/post`, {});
  }

  public delete(id: string): Observable<ApiResponse<unknown>> {
    return this.httpClient.delete<ApiResponse<unknown>>(`${this.baseUrl}/${id}`);
  }

  public search(
    command: BankTransactionSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    matchAny = false,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PagedResult<BankTransaction>>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('matchAny', matchAny)
      .set('sortOrder', sortOrder);
    if (sortField) params = params.set('sortField', sortField);
    return this.httpClient.post<ApiResponse<PagedResult<BankTransaction>>>(`${this.baseUrl}/search`, command, { params });
  }
}
